<div class="card col-md-2">
    <div class="card-body">
        <h3>Exception example</h3>
        <hr />
        <div class="text-center">
            <button type="button" class="btn btn-danger" (click)="triggerException()">Trigger Exception</button>
            <hr />
            <p>Trigger a server side exception by clicking the button.</p>
        </div>
    </div>
</div>